<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h3>SIM Package History</h3>
        <button class="btn btn-secondary" (click)="goBack()">Back to SIM</button>
      </div>

      <!-- Loading indicator -->
      @if (loading) {
        <div class="d-flex justify-content-center mt-5">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      }

      <!-- Error message -->
      @if (error && !loading) {
        <div class="alert alert-danger mt-3">
          {{ error }}
        </div>
      }

      <!-- Package history list -->
      @if (!loading && !error) {
        <div class="mt-4">
          <h5>Package History for ICCID: {{ iccid }}</h5>
          @if (packageHistory.length > 0) {
            <div class="row mt-4">
              @for (pkg of packageHistory; track pkg) {
                <div class="col-lg-6 col-md-12 col-sm-12 mb-4">
                  <div class="card h-100">
                    <div class="card-body">
                      <h5 class="card-title">{{ pkg.package.title }}</h5>
                      <p class="card-text"><strong>Package ID:</strong> {{ pkg.package.id }}</p>
                      <p class="card-text"><strong>Type:</strong> {{ pkg.package.type }}</p>
                      <p class="card-text"><strong>Validity:</strong> {{ pkg.package.day }} days</p>
                      <p class="card-text"><strong>Data:</strong> {{ pkg.package.data }}</p>
                      <p class="card-text"><strong>Amount:</strong> {{ pkg.package.amount }}</p>
                      <p class="card-text"><strong>Price:</strong> {{ pkg.package.price }}</p>
                      <p class="card-text"><strong>Is Unlimited:</strong> {{ pkg.package.is_unlimited ? 'Yes' : 'No' }}</p>
                      <p class="card-text"><strong>Status:</strong>
                      <span class="badge" [class]="'badge-' + (pkg.status === 'ACTIVE' ? 'success' : pkg.status === 'EXPIRED' ? 'secondary' : 'danger')">{{ pkg.status }}</span>
                    </p>
                    @if (pkg.activated_at) {
                      <p class="card-text"><strong>Activated At:</strong> {{ formatDate(pkg.activated_at) }}</p>
                    }
                    @if (pkg.expired_at) {
                      <p class="card-text"><strong>Expired At:</strong> {{ formatDate(pkg.expired_at) }}</p>
                    }
                    @if (pkg.finished_at) {
                      <p class="card-text"><strong>Finished At:</strong> {{ formatDate(pkg.finished_at) }}</p>
                    }
                    @if (pkg.package.short_info) {
                      <p class="card-text"><strong>Info:</strong> {{ pkg.package.short_info }}</p>
                    }
                    <p class="card-text"><strong>Remaining:</strong> {{ pkg.remaining }}</p>
                  </div>
                </div>
              </div>
            }
          </div>
        }
        <!-- No package history message -->
        @if (!loading && !error && packageHistory.length === 0) {
          <div class="alert alert-info mt-3">
            No package history available for this SIM.
          </div>
        }
      </div>
    }
  </div>
</div>
</div>